module.exports = __webpack_public_path__ + "img/hr-brown-fluff-18.ee39d8e7.png";